<template>
  <div
    class="tw:mb-2 tw:flex tw:items-center tw:justify-center tw:gap-1 tw:text-sm/[1.4] tw:font-normal tw:tracking-normal tw:text-denim-900"
    data-testid="chart-social-account-label"
  >
    <img
      alt=""
      class="tw:size-3.5 tw:shrink-0"
      data-testid="chart-social-account-icon"
      :src="platformIcon"
    />

    {{ label }}
  </div>
</template>

<script setup lang="ts">
export interface ChartSocialAccountLabelProps {
  label: string;
  platformIcon: string;
}

defineProps<ChartSocialAccountLabelProps>();
</script>
